import React from 'react';
import ContentTitle from '../molecules/ContentTitle';

const PricePage = () => (
  <>
    <div style={{ width: '100%', marginTop: '20px' }} className="noselect">
      <span style={{ fontSize: '18pt' }}>
        <b>
          {process.env.REACT_APP_COMPANY}
          만의 최고의 기술력과 정성을 다한
          노력의
        </b>
        <br />
        <b>합리적인 줄눈 시공 가격을 제시합니다!</b>
      </span>
    </div>
    <div style={{ width: '100%', marginTop: '20px' }} className="noselect">
      <ContentTitle
        title="가격안내"
        isClearAfter
        style={{ container: { marginTop: '20px' } }}
      />
      <br />
      <b style={{ fontSize: '14pt' }}>
        타일줄눈시공을 전문으로하는 미래줄눈
        <br />
        {' '}
        줄눈 시공 가격을 표준화 하였습니다
        <br />
        {' '}
        고객여러분의 많은 사랑 부탁드립니다 감사합니다
        <br />
      </b>
      <b style={{ fontSize: '15pt' }}>-미래줄눈-</b>
      <br />
      <br />
      <b style={{ fontSize: '13pt', color: 'blue' }}>
        - 전시장 , 숙박시설 공공기관 대단위시설 별도상담 신청해주시면
        방문상담 가능합니다
      </b>
      <br />
      <b style={{ fontSize: '12pt' }}>
        <br />
        - 모든 금액은 현금가 기준입니다.
        <br />
        - 카드결제는 예약시 미리 말씀해주셔야하며 부가세는 별도입니다.
        <br />
        - 시공 타일 크기에 따라 가격 변동이 생길 수 있습니다.
        <br />
        - 신축 30평형 확장형기준, 구축기준, 줄눈재시공 가격입니다, 무료 상담 신청 부탁드립니다.
        <br />
        <br />
        <b style={{ color: 'red' }}>
          <br />
          * 본사, 직영 사장님이 직접 시공합니다.
        </b>
      </b>
    </div>

    <div
      style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}
      className="noselect"
    >
      <table className="priceTable" cellSpacing="1" cellPadding="0">
        <caption>
          바닥타일 줄눈시공 표준가격
          <br />
          ( 30cm
          <sup>2</sup>
          {' '}
          타일 기준 )
        </caption>
        <thead>
          <tr>
            <th style={{ minWidth: 100 }}>구분</th>
            <th>신축</th>
            <th>구축</th>
            <th>줄눈재시공</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>현관입구</td>
            <td>5만원</td>
            <td>7만원</td>
            <td>10만원</td>
          </tr>
          <tr>
            <td>거실욕실</td>
            <td>10만원</td>
            <td>15만원</td>
            <td>25만원</td>
          </tr>
          <tr>
            <td>안방욕실</td>
            <td>12만원</td>
            <td>20만원</td>
            <td>30만원</td>
          </tr>
          <tr>
            <td>베란다</td>
            <td>10만원</td>
            <td>15만원</td>
            <td>25만원</td>
          </tr>
          <tr>
            <td>대피공간</td>
            <td>5만원</td>
            <td>7만원</td>
            <td>10만원</td>
          </tr>

          <tr>
            <td>세탁실</td>
            <td>8만원</td>
            <td>10만원</td>
            <td>20만원</td>
          </tr>
        </tbody>
      </table>

      <table className="priceTable" cellSpacing="1" cellPadding="0">
        <caption>
          벽타일 줄눈시공 가격
          <br />
          ( 60cm X 30cm 타일 기준)
        </caption>
        <thead>
          <tr>
            <th>구분</th>
            <th>신축</th>
            <th>구축</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>아트월</td>
            <td>20만원</td>
            <td>25만원</td>
          </tr>
          <tr>
            <td>거실욕실</td>
            <td>30만원</td>
            <td>35만원</td>
          </tr>
          <tr>
            <td>안방욕실</td>
            <td>30만원</td>
            <td>35만원</td>
          </tr>
          <tr>
            <td>샤워부스</td>
            <td>15만원</td>
            <td>20만원</td>
          </tr>
          <tr>
            <td>주방벽면</td>
            <td>10만원</td>
            <td>15만원</td>
          </tr>
        </tbody>
      </table>
      <table className="priceTable" cellSpacing="1" cellPadding="0">
        <caption>
          폴리싱타일 및 대리석 줄눈시공가격 타일크기 기준 60cm 정사각 /3.3m
          <sup>2</sup>
        </caption>
        <thead>
          <tr>
            <th>구분</th>
            <th>신축</th>
            <th>구축</th>
            <th>줄눈재시공</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>폴리싱타일</td>
            <td>4만원</td>
            <td>6만원</td>
            <td>10만원</td>
          </tr>
          <tr>
            <td>복합대리석</td>
            <td>7만원</td>
            <td>10만원</td>
            <td>15만원</td>
          </tr>
          <tr>
            <td>천연대리석</td>
            <td>10만원</td>
            <td>15만원</td>
            <td>20만원</td>
          </tr>
        </tbody>
      </table>
      <table className="priceTable" cellSpacing="1" cellPadding="0">
        <caption>실리콘 오염방지 및 재시공 가격</caption>
        <thead>
          <tr>
            <th>구분</th>
            <th>오염방지</th>
            <th>
              재시공 &
              오염방지
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>욕실 테두리</td>
            <td>5만원</td>
            <td>10만원</td>
          </tr>
          <tr>
            <td>공용욕실전체</td>
            <td>7만원</td>
            <td>15만원</td>
          </tr>
          <tr>
            <td>안방욕실전체</td>
            <td>7만원</td>
            <td>15만원</td>
          </tr>
        </tbody>
      </table>
    </div>

    {/* <div
        style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}
        className="noselect"
      >
        <table className="priceTable" cellSpacing="1" cellPadding="0">
          <caption>욕실, 베란다 등(신축 기준)</caption>
          <thead>
            <tr>
              <th rowSpan={2}>평형 / 종류</th>
              <th colSpan={2}>욕실</th>
              <th rowSpan={2}>현관</th>
              <th rowSpan={2}>베란다</th>
              <th rowSpan={2}>
                주방
                <br />
                벽면
              </th>
            </tr>
            <tr>
              <th>바닥</th>
              <th>벽</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> 25평 </td>
              <td>8만원</td>
              <td>20만원</td>
              <td>3만원</td>
              <td>5만원</td>
              <td>8만원</td>
            </tr>
            <tr>
              <td> 30평 </td>
              <td>10만원</td>
              <td>25만원</td>
              <td>3만원</td>
              <td>7만원</td>
              <td>10만원</td>
            </tr>
            <tr>
              <td> 40평 </td>
              <td>12만원</td>
              <td>27만원</td>
              <td>5만원</td>
              <td>8만원</td>
              <td>12만원</td>
            </tr>
            <tr>
              <td> 50평 </td>
              <td>15만원</td>
              <td>29만원</td>
              <td>6만원</td>
              <td>10만원</td>
              <td>16만원</td>
            </tr>
            <tr>
              <td> 60평 </td>
              <td>20만원</td>
              <td>30만원</td>
              <td>7만원</td>
              <td>15만원</td>
              <td>20만원</td>
            </tr>
          </tbody>
        </table>
        <table className="priceTable" cellSpacing="1" cellPadding="0">
          <caption>실리콘 코팅</caption>
          <thead>
            <tr>
              <th>구분</th>
              <th>단가</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>욕실 욕조포함 전체(개당)</td>
              <td>7만원 ~ 10만원</td>
            </tr>
            <tr>
              <td>욕실 전체(개당)</td>
              <td>5만원 ~ 7만원</td>
            </tr>
            <tr>
              <td>주방 싱크대 전체</td>
              <td>3만원 ~ 5만원</td>
            </tr>
          </tbody>
        </table>
        <table className="priceTable" cellSpacing="1" cellPadding="0">
          <caption>
            폴리싱 타일 대리석(신축 기준)
            <br />
            (거실, 주방, 복도)
          </caption>
          <thead>
            <tr>
              <th>종류</th>
              <th>
                평당(3.3m<sup>2</sup>)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>폴리싱타일</td>
              <td>4만원 부터</td>
            </tr>
            <tr>
              <td>대리석</td>
              <td colSpan={4} rowSpan={1}>
                별도 상담 요망
              </td>
            </tr>
            <tr>
              <td>관공서 다중이용시설&nbsp; 상업시설 등</td>
              <td colSpan={4} rowSpan={1}>
                별도 상담 요망
              </td>
            </tr>
          </tbody>
        </table>
      </div> */}
  </>
);

export default PricePage;
